import { render, staticRenderFns } from "./lastfmCallback.vue?vue&type=template&id=5685dc97&scoped=true&"
import script from "./lastfmCallback.vue?vue&type=script&lang=js&"
export * from "./lastfmCallback.vue?vue&type=script&lang=js&"
import style0 from "./lastfmCallback.vue?vue&type=style&index=0&id=5685dc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685dc97",
  null
  
)

export default component.exports